<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card class="pa-3">
            <div class="mb-3">
                <h2>รายงานต้นทุนขายรายวัน</h2>
            </div>
            <div class="mb-3 d-flex option_date_daily_cost_report_list">
                <div>
                    <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date_be" label="เลือกวันที่ (วัน/เดือน/ปี)" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" outlined></v-text-field>
                        </template>
                        <v-date-picker v-model="date" :max="max_date" no-title scrollable locale="th" :events="dateStartEndBE('date')">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="searchDate()">
                                ตกลง
                            </v-btn>
                            <v-btn text color="primary" @click="menu_date = false">
                                ยกเลิก
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
            </div>
            <div>
                <div class="grid_daily_cost_report_list mb-3">
                    <div class="mr-1">
                        <v-card class="pa-3 mb-3 white--text" color="success">
                            รายได้
                        </v-card>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>รายได้ร้านอาหาร</div>
                                <div>{{ income_store }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>รายได้ค้างรับ</div>
                                <div>{{ income_accrued }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="mb-3 d-flex justify-space-between">
                            <div>รวมรายได้</div>
                            <div>{{ sum_income }}</div>
                        </div>
                        <v-card class="pa-3 mb-3 white--text" color="error">
                            ต้นทุน
                        </v-card>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>ต้นทุนวัตถุดิบ</div>
                                <div>{{ cost_material }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="mb-3">
                            <div class="pl-3 pb-3 d-flex justify-space-between">
                                <div>ต้นทุนอื่นๆ</div>
                                <div>{{ cost_other }}</div>
                            </div>
                            <hr>
                        </div>
                        <div class="d-flex justify-space-between">
                            <div>รวมต้นทุน</div>
                            <div>{{ sum_cost }}</div>
                        </div>
                    </div>
                    <div class="ml-1">
                        <v-card class="pa-3 mb-3">
                            กำไรสุทธิ
                        </v-card>
                        <div class="chart_daily_cost_report_list d-flex justify-center align-center">
                            <canvas id="my-chart-out"></canvas>
                        </div>
                    </div>

                </div>
            </div>
        </v-card>

    </div>
</div>
</template>

<script>
import dailycostreport from '@/api/account/accountreport/dailycostreport.js'
import Chart from 'chart.js'
// import 'chartjs-plugin-labels'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            menu_date: false,
            date_be: '',
            date: '',
            income_store: 0,
            income_accrued: 0,
            sum_income: 0,
            cost_material: 0,
            cost_other: 0,
            sum_cost: 0,
        }
    },

    methods: {
        dateStartEndBE(type) {
            if (type == 'date') {
                if (this.date == '') {
                    this.date_be = ''
                }
                if (this.date) {
                    let date_arr = this.date.split('-')
                    let year = parseInt(date_arr[0]) + 543
                    let month = parseInt(date_arr[1]) - 1
                    month = this.$store.state.monthList[month].name_short
                    this.date_be = `${date_arr[2]}/${month}/${year}`
                }
            }
        },
        async searchDate() {
            this.$refs.menu_date.save(this.date)
            let date_arr = this.date.split('-')
            let year = parseInt(date_arr[0]) + 543
            let month = parseInt(date_arr[1]) - 1
            month = this.$store.state.monthList[month].name_short
            this.date_be = `${date_arr[2]}/${month}/${year}`
            this.menu_date = false
            this.chartAll()
        },
        async chartAll() {
            this.loading_page = true
            await dailycostreport.dailyCostReportList(this.date).then((response) => {
                if (response.data.successful === true) {
                    this.income_store = response.data.detail.incomStore
                    this.income_accrued = response.data.detail.incomAccrued
                    this.sum_income = response.data.detail.sumIncom
                    this.cost_material = response.data.detail.costMat
                    this.cost_other = response.data.detail.costOther
                    this.sum_cost = response.data.detail.sumCost
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            let ctx_out = document.getElementById('my-chart-out')
            const all_income_cost = [this.sum_income, this.sum_cost]
            new Chart(ctx_out, {
                type: 'bar',
                data: {
                    labels: ['รายได้', 'ต้นทุน'],
                    datasets: [{
                        data: [this.sum_income, this.sum_cost],
                        backgroundColor: ['#09CE33', '#FF5252'],
                    }, ]
                },
                options: {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        labels: {
                            render: 'value',
                            fontColor: ['#000000', '#000000'],
                            precision: 2
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                max: Math.max(...all_income_cost) + 1000,
                                beginAtZero: true
                            }
                        }]
                    },
                }
            })
        }
    },
    computed: {
        max_date() {
            const dateTodayList = new Date();
            let date_month = dateTodayList.getMonth() + 1
            if (date_month < 10) {
                date_month = '0' + date_month
            }
            let date_day = dateTodayList.getDate()
            if (date_day < 10) {
                date_day = '0' + date_day
            }
            const date_today = dateTodayList.getFullYear() + '-' + date_month + '-' + date_day
            return date_today
        }
    },
    mounted() {
        this.chartAll()
    }

}
</script>

<style scoped>
.option_date_daily_cost_report_list>div {
    width: 40%;
}

.grid_daily_cost_report_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.chart_daily_cost_report_list {
    height: 80%;
}
</style>
